module.exports = __webpack_public_path__ + "img/c-en-06.3a4e6d1e.png";